import { ListingDiscountModel } from '@loavies/c2c-models'
import { mapPrice } from './price-mappers'

/**
 * @param {Object} discount
 * @returns {loavies.models.listing.ListingDiscountModel}
 */
export function mapDiscount(discount) {
  return new ListingDiscountModel({
    discountPercentage: discount.discountPercentage,
    originalPrice: mapPrice(discount.originalPrice),
  })
}
